module.exports = __webpack_public_path__ + "img/24.6d8e0567.svg";